module.exports = __webpack_public_path__ + "media/dogs/xmas-dog-with-hat-d166e3e5.svg";